(function () {
  "use strict";

  const STORAGE_KEY = "bdsm_cart_snapshot_v1";
  const originalFetch = window.fetch.bind(window);

  let checkTimer = null;
  let checkingCart = false;

  function getCartUrl() {
    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    return root + "cart.js";
  }

  function createSnapshot(cart) {
    return {
      totalPrice: Number(cart.total_price || 0),
      itemCount: Number(cart.item_count || 0),
      currency:
        cart.currency ||
        (
          window.Shopify &&
          window.Shopify.currency &&
          window.Shopify.currency.active
        ) ||
        "CHF"
    };
  }

  function readSnapshot() {
    try {
      const saved = sessionStorage.getItem(STORAGE_KEY);

      if (!saved) return null;

      return JSON.parse(saved);
    } catch (error) {
      console.warn(
        "Warenkorb-Snapshot konnte nicht gelesen werden:",
        error
      );

      return null;
    }
  }

  function saveSnapshot(snapshot) {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(snapshot)
      );
    } catch (error) {
      console.warn(
        "Warenkorb-Snapshot konnte nicht gespeichert werden:",
        error
      );
    }
  }

  function isCartMutation(request) {
    const url =
      typeof request === "string"
        ? request
        : request && request.url
          ? request.url
          : "";

    return /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/i.test(
      url
    );
  }

  async function getCurrentCart() {
    const response = await originalFetch(getCartUrl(), {
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(
        "Der aktuelle Warenkorb konnte nicht geladen werden."
      );
    }

    return response.json();
  }

  async function sendCartValueEvent(
    previousCart,
    currentCart,
    trigger
  ) {
    if (
      !window.klaviyo ||
      typeof window.klaviyo.track !== "function"
    ) {
      console.warn(
        "Klaviyo ist für Warenkorb-Tracking nicht verfügbar."
      );

      return;
    }

    const previousValue = Number(
      (previousCart.totalPrice / 100).toFixed(2)
    );

    const currentValue = Number(
      (currentCart.totalPrice / 100).toFixed(2)
    );

    const valueDifference = Number(
      (currentValue - previousValue).toFixed(2)
    );

    let direction = "Unverändert";

    if (valueDifference > 0) {
      direction = "Erhöht";
    } else if (valueDifference < 0) {
      direction = "Verringert";
    }

    try {
      await Promise.resolve(
        window.klaviyo.track(
          "Warenkorbwert geändert",
          {
            VorherigerWarenkorbwert: previousValue,
            NeuerWarenkorbwert: currentValue,
            Wertänderung: valueDifference,
            Änderungsrichtung: direction,
            VorherigeArtikelanzahl:
              previousCart.itemCount,
            NeueArtikelanzahl:
              currentCart.itemCount,
            Währung: currentCart.currency,
            Auslöser: trigger,
            Seite: window.location.href
          }
        )
      );

      console.log(
        "Warenkorbwert geändert sent to Klaviyo"
      );
    } catch (error) {
      console.error(
        "Fehler beim Warenkorbwert-Tracking:",
        error
      );
    }
  }

  async function checkCart(trigger) {
    if (checkingCart) return;

    checkingCart = true;

    try {
      const cart = await getCurrentCart();
      const currentCart = createSnapshot(cart);
      const previousCart = readSnapshot();

      if (!previousCart) {
        saveSnapshot(currentCart);
        return;
      }

      const valueChanged =
        previousCart.totalPrice !==
        currentCart.totalPrice;

      const quantityChanged =
        previousCart.itemCount !==
        currentCart.itemCount;

      if (valueChanged || quantityChanged) {
        await sendCartValueEvent(
          previousCart,
          currentCart,
          trigger
        );
      }

      saveSnapshot(currentCart);
    } catch (error) {
      console.error(
        "Warenkorb konnte nicht geprüft werden:",
        error
      );
    } finally {
      checkingCart = false;
    }
  }

  function scheduleCartCheck(trigger) {
    clearTimeout(checkTimer);

    checkTimer = setTimeout(function () {
      checkCart(trigger);
    }, 700);
  }

  window.fetch = function () {
    const request = arguments[0];

    return originalFetch
      .apply(window, arguments)
      .then(function (response) {
        if (
          response.ok &&
          isCartMutation(request)
        ) {
          scheduleCartCheck(
            "Warenkorb über Ajax geändert"
          );
        }

        return response;
      });
  };

  const originalXhrOpen =
    XMLHttpRequest.prototype.open;

  const originalXhrSend =
    XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (
    method,
    url
  ) {
    this.__bdsmCartRequestUrl = String(url || "");

    return originalXhrOpen.apply(
      this,
      arguments
    );
  };

  XMLHttpRequest.prototype.send = function () {
    const xhr = this;

    if (
      isCartMutation(xhr.__bdsmCartRequestUrl)
    ) {
      xhr.addEventListener(
        "loadend",
        function () {
          if (
            xhr.status >= 200 &&
            xhr.status < 400
          ) {
            scheduleCartCheck(
              "Warenkorb über XHR geändert"
            );
          }
        },
        { once: true }
      );
    }

    return originalXhrSend.apply(
      this,
      arguments
    );
  };

  checkCart("Seitenaufruf");
})();